<template>
    <div class="column-list">
        <div class="column-item" v-for="(item, index) in list" :key="index">
            <img class="left-img" :src="item.img">
            <div class="detail-box">
                <p class="title">{{item.title}}</p>
                <p class="des">{{item.des}}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        list: {
            type: Array,
            default: () => []
        }
    }
}
</script>
<style lang="scss" scoped>
.column-list{
    padding: 0px 20px;
    color: #282828;
    .column-item{
        width: 100%;
        background: #F8F9FD;
        border-radius: 4px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 10px;
        padding: 10px 0px;
        .left-img{
            width: 120px;
        }
        .detail-box{
            margin-left: 8px;
            text-align: left;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            flex: 1;
            .title{
                font-size:12px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                line-height:17px;
            }
            .des{
                margin-top: 7px;
                font-size:10px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                line-height:14px;
            }
        }
        &:last-of-type{
            margin-bottom: 0px;
        }
    }
}
</style>